<template>
    <footer :class="['footer', { 'dark-mode': isDarkMode }]">
        <div class="container my-5" v-if="currentPath !== '/login'">
            <div class="row">
                <!-- Vision & Mission -->
                <div class="col-12 col-md-4">
                    <h3 class="column-title">Why Us?</h3>
                    <p class="column-subtitle">
                        We are your blueprint for success.
                    </p>
                    <div class="flex flex-column mt-5">
                        <img
                            src="/img/logo-only.png"
                            alt="Tennt Enterprises, Inc."
                            class="company-logo mb-3"
                        />
                        <div class="d-flex flex-column gap-2">
                            <div>
                                <h5 class="section-title">Vision</h5>
                                <p class="section-content">
                                    The Preferred Construction Supplies Provider
                                </p>
                            </div>
                            <div>
                                <h5 class="section-title">Mission</h5>
                                <p class="section-content">
                                    We are committed to providing quality
                                    construction supplies that offer exceptional
                                    value to our business partners.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Contact Information -->
                <div class="col-12 col-md-4">
                    <h3 class="column-title">Need Help?</h3>
                    <p class="column-subtitle">You can count on us.</p>
                    <div class="d-flex flex-column gap-3 mt-5">
                        <div class="d-flex align-items-center gap-2">
                            <font-awesome-icon
                                :icon="['fas', 'phone']"
                                size="md"
                            />
                            <h5 class="section-title mb-0">Contact Us</h5>
                        </div>
                        <div class="d-flex flex-column">
                            <h6>Landline</h6>
                            <span
                                class="section-content"
                                @click="callOption('(082) 227 8892')"
                                >(082) 227 8892</span
                            >
                            <span
                                class="section-content"
                                @click="callOption('(082) 227 3658')"
                                >(082) 227 3658</span
                            >
                            <span
                                class="section-content"
                                @click="callOption('(082) 227 2055')"
                                >(082) 227 2055</span
                            >
                            <span
                                class="section-content"
                                @click="callOption('(082) 227 1227')"
                                >(082) 227 1227</span
                            >
                        </div>
                        <div class="d-flex flex-column">
                            <h6>Mobile</h6>
                            <span class="section-content" @click="callOption"
                                >0995 290 2387</span
                            >
                            <span class="section-content" @click="callOption"
                                >0997 209 5425</span
                            >
                        </div>
                        <div class="d-flex flex-column">
                            <h6>Email</h6>
                            <a
                                href="mailto:orders@tennyinc.com"
                                class="section-content"
                                style="text-decoration: none"
                            >
                                orders@tennyinc.com
                            </a>
                        </div>
                    </div>
                    <div class="d-flex flex-column gap-3 mt-5">
                        <div class="d-flex align-items-center gap-2">
                            <font-awesome-icon
                                :icon="['fas', 'globe']"
                                size="md"
                                @click="goToFacebook"
                            />
                            <h5 class="section-title mb-0">Social Media</h5>
                        </div>
                        <div class="d-flex flex-column">
                            <h6>Facebook Page</h6>
                            <span class="section-content" @click="goToFacebook"
                                >Tenny Enterprises, Inc.</span
                            >
                        </div>
                        <div class="d-flex flex-column">
                            <h6>Instagram</h6>
                            <span class="section-content" @click="goToFacebook"
                                >Tenny Enterprises, Inc.</span
                            >
                        </div>
                    </div>
                </div>
                <!-- Location -->
                <div class="col-12 col-md-4">
                    <h3 class="column-title">Visit Us</h3>
                    <p class="column-subtitle">We are here waiting for you!</p>
                    <div class="d-flex flex-column mt-5">
                        <div class="d-flex flex-column gap-3">
                            <div class="d-flex align-items-center gap-2">
                                <font-awesome-icon
                                    :icon="['fas', 'calendar']"
                                    size="md"
                                />
                                <h5 class="section-title mb-0">Schedule</h5>
                            </div>
                            <div class="d-flex flex-column">
                                <h6>Open</h6>
                                <span class="section-content"
                                    >Monday to Saturday</span
                                >
                            </div>
                            <div class="d-flex flex-column">
                                <h6>Office Hours</h6>
                                <span class="section-content"
                                    >7:30 AM - 5:30 PM (NO NOON BREAK)</span
                                >
                            </div>
                            <div class="d-flex flex-column">
                                <h6>Pickup Time</h6>
                                <span class="section-content"
                                    >8:00 AM - 4:30 PM (NO NOON BREAK)</span
                                >
                            </div>
                        </div>
                    </div>
                    <div class="d-flex flex-column mt-5">
                        <div class="d-flex flex-column gap-3">
                            <div class="d-flex align-items-center gap-2">
                                <font-awesome-icon
                                    :icon="['fas', 'location-dot']"
                                    size="md"
                                />
                                <h5 class="section-title mb-0">Location</h5>
                            </div>
                            <div class="d-flex flex-column">
                                <h6>Head Office</h6>
                                <span class="section-content"
                                    >Sta. Ana Avenue, Barangay 15-B, Poblacion
                                    District, Davao City, Davao Del Sur</span
                                >
                            </div>
                            <div class="d-flex flex-column">
                                <h6>Landmark</h6>
                                <span class="section-content"
                                    >Beside BDO Sta. Ana Avenue, Corner Gempesaw
                                    St.</span
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
            class="border-top border-1 pt-5 text-center"
            v-if="currentPath !== '/login'"
        >
            <p>
                <span class="mx-3">Terms of Use</span> |
                <span class="mx-3">Privacy Policy</span>
            </p>
            <font-awesome-icon :icon="['far', 'copyright']" /> 2024 Tenny
            Enterprises Inc. All rights reserved.
        </div>
    </footer>
</template>

<script src="./FooterScript.vue" />
